import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { FinanceService } from 'src/app/services/finance.service';
import { LibService } from '../../services/libService';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-modal-project-costs',
  templateUrl: './modal-project-costs.component.html',
  styleUrls: ['./modal-project-costs.component.scss']
})
export class ModalProjectCosts implements OnInit {

  code: any = null;
  account: any = null;
  projectCosts: any = [];
  dataSource: MatTableDataSource<any>;
  displayedColumns: string[] = [
    'Expenditure_Date',
    'Item_Number',
    'Description',
    'Quantity',
    'Value',
    'Unit_Of_Measure',
    'Currency',
    'NumeroDocumento',
  ];

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private financeService: FinanceService,
    private libService: LibService,
    private toastr: ToastrService,
    private translate: TranslateService
  ) {

    if (data) {
      this.code = data.code;
      this.account = data.account;
    }

  }

  ngOnInit(): void {
    this.libService.lockPage('Loading data...');
    this.financeService.getProjectCosts(this.account, this.code).subscribe((response) => {
      this.libService.unlockPage();
      console.log(response);
      if (response.esito == 'OK') {
        let res: any = response.item.Table

        if (res.length > 0) {
          this.projectCosts = res;
          this.dataSource = new MatTableDataSource(this.projectCosts);
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
        }

      } else {
        console.log("CATCH ERROR PATCH VALUE REQUEST");
        // aggiungi un taoast di errore
        this.libService.unlockPage();
        this.toastr.error(this.translate.instant('LABEL.DATA_ERROR'), this.translate.instant('TOASTR.WARNING'));
      }
console.log(this.projectCosts)
    });
  }
}
